import { render, staticRenderFns } from "./deleteQuestionTitle.vue?vue&type=template&id=0797e767&scoped=true"
import script from "./deleteQuestionTitle.vue?vue&type=script&lang=js"
export * from "./deleteQuestionTitle.vue?vue&type=script&lang=js"
import style0 from "./deleteQuestionTitle.vue?vue&type=style&index=0&id=0797e767&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0797e767",
  null
  
)

export default component.exports